// Insert a space before all caps
// Then uppercase the first character
export const camelToTitle = (camelCase: string) => {
  return camelCase.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
};
